import { useNavigate } from "react-router-dom";
import { Button } from "../components/common";
import { useParentBridge } from "../hooks/useParentBridge";
import "./LandingPage.scss";

const LandingPage = () => {
  const navigate = useNavigate();
  const { postToParent } = useParentBridge();


  const handleStart = () => {
    // Clear any previous complaint checker state to ensure fresh start
    sessionStorage.removeItem("complaintChecker");
    navigate("/complaint-checker");
  };

  const handleCancel = () => {
    postToParent({ type: "NAVIGATE_BACK" });
  };

  return (
    <div className="landing-page">
      <div className="landing-content">
        <div className="landing-header">
          <span className="landing-label">Complaint Checker</span>
          <h1 className="landing-title">Make a new complaint</h1>
        </div>

        <div className="landing-page__divider" />

        <div className="landing-body">
          <div>
            <p className="landing-intro">
              <strong>Before we can help you with your complaint</strong>
            </p>
            <div className="landing-bullets">
              <p>You will need to:</p>
              <ul>
                <li>
                  <p>
                    have already complained to the organisation you are unhappy
                    with
                  </p>
                </li>
                <li>
                  <p>
                    have a final response from the organisation that has
                    addressed all the concerns you raised with them
                  </p>
                </li>
              </ul>
            </div>
            <p>
              Once all your concerns are addressed, if you are still not happy,
              then you can complain to us.
            </p>
          </div>
          <div>
            <p className="landing-intro">
              <strong>We may not be able to help you if:</strong>
            </p>
            <div className="landing-bullets">
              <ul>
                <li>
                  <p>your complaint is over 12 months old</p>
                </li>
                <li>
                  <p>you are taking legal action</p>
                </li>
                <li>
                  <p>
                    the organisation's final response has not addressed all the
                    issues you raised - for help with this phone us on{" "}
                    <a href="tel:03450154033">0345 015 4033</a> or visit our
                    website for advice on how to make a complaint:{" "}
                    <a
                      href="https://www.ombudsman.org.uk/complainforchange"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.ombudsman.org.uk/complainforchange
                    </a>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="btn-group-wrapper">
          <div className="btn-group-divider"></div>
          <div className="btn-group">
            <Button variant="cancel" onClick={handleCancel}>
              Cancel
            </Button>
            <Button variant="continuation" onClick={handleStart}>
              Start
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
